export const SIZE_LIMIT = 12;
export const ORDERS = {
	ASC: 'ASC',
	DESC: 'DESC',
};
